import { render, staticRenderFns } from "./TemplatingTasks.vue?vue&type=template&id=1806e0e2&scoped=true"
import script from "./TemplatingTasks.vue?vue&type=script&lang=js"
export * from "./TemplatingTasks.vue?vue&type=script&lang=js"
import style0 from "./TemplatingTasks.vue?vue&type=style&index=0&id=1806e0e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1806e0e2",
  null
  
)

export default component.exports